<template>
  <div class="partner-banner" :style="{ background: bannerBackground }">
    <div class="background-animation"></div>
    <div class="banner-content">
      <div class="left-section">
        <img :src="logoSrc" :alt="`${title} Logo`" class="partner-logo" />

<!--        <div v-if="isWorking" class="partner-announcement">-->
<!--          <h2>🎉 {{ $t("lang.partnerAnnouncementTitle") }}</h2>-->
<!--          <p>{{ $t("lang.partnerAnnouncement") }} {{ title }}</p>-->
<!--        </div>-->

        <h1 class="banner-title">
          <span class="color-text">{{ title }}</span>
        </h1>

        <p class="banner-description">{{ description }}</p>

        <div class="btn-container">
          <button class="explore-btn" @click="visitWebsite">{{ buttonText }}</button>
        </div>
      </div>

      <div class="right-section">
        <div v-for="(row, index) in widgets" :key="index" class="widget-row">
          <div v-for="widget in row" :key="widget.title" class="widget">
            <h3>{{ widget.title }}</h3>
            <p v-if="widget.content" v-html="widget.content"></p>
            <ul v-if="widget.items">
              <li v-for="item in widget.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    logoSrc: String,
    description: String,
    buttonText: String,
    websiteUrl: String,
    bannerBackground: String,
    isWorking: Boolean,
    widgets: Array
  },
  methods: {
    visitWebsite() {
      window.open(this.websiteUrl, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.partner-banner {
  width: 100%;
  height: 580px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  color: black;
  margin-bottom: 40px;

  .background-animation {
    position: absolute;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.2) 10%, transparent 70%);
    top: -50%;
    left: -50%;
    animation: animateBackground 8s linear infinite;
  }

  @keyframes animateBackground {
    0% { transform: rotate(0deg) scale(1); }
    50% { transform: rotate(45deg) scale(1.2); }
    100% { transform: rotate(0deg) scale(1); }
  }

  .banner-content {
    z-index: 2;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .left-section {
    width: 45%;
    .partner-logo {
      width: 100px;
      margin-bottom: 10px;
    }
    .partner-announcement {
      padding: 10px 15px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.2);
      text-align: center;
      margin-bottom: 15px;
      h2 {
        font-size: 18px;
        margin-bottom: 5px;
      }
      p {
        font-size: 16px;
      }
    }
    .banner-title {
      font-size: 45px;
      margin-bottom: 10px;
    }
    .color-text {
      background: linear-gradient(90deg, rgba(242, 106, 255, 1), rgba(125, 111, 255, 1));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .banner-description {
      font-size: 17px;
    }
    .btn-container {
      margin-top: 20px;
    }
    .explore-btn {
      padding: 12px 24px;
      font-size: 16px;
      font-weight: bold;
      background: linear-gradient(45deg, #007bff, #00ffcc);
      border: none;
      border-radius: 30px;
      cursor: pointer;
      color: #fff;
      transition: all 0.3s ease;
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .right-section {
    width: 50%;
    display: flex;
    flex-direction: column;
    .widget-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      .widget {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 15px;
        padding: 15px;
        width: 48%;
        text-align: center;
        h3 {
          font-size: 18px;
          color: #00ffcc;
          margin-bottom: 8px;
        }
        p,
        ul {
          font-size: 16px;
          font-weight: bold;
        }
        ul {
          list-style: none;
          padding: 0;
          li {
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}

/* Responsive Styles for Phones */
@media (max-width: 600px) {
  .partner-banner {
    height: auto;
    padding: 20px;
    .banner-content {
      flex-direction: column;
      align-items: center;
    }
    .left-section,
    .right-section {
      width: 100%;
      text-align: center;
    }
    .left-section {
      .partner-logo {
        width: 80px;
      }
      .banner-title {
        font-size: 32px;
      }
      .banner-description {
        font-size: 15px;
      }
      .explore-btn {
        font-size: 14px;
        padding: 10px 20px;
      }
    }
    .right-section {
      margin-top: 20px;
      .widget-row {
        flex-direction: column;
        .widget {
          width: 100%;
          margin-bottom: 15px;
        }
      }
    }
  }
}

/* Responsive Styles for Tablets/iPads */
@media (min-width: 601px) and (max-width: 1024px) {
  .partner-banner {
    height: auto;
    padding: 30px;
    .banner-content {
      flex-direction: column;
      align-items: center;
    }
    .left-section,
    .right-section {
      width: 100%;
      text-align: center;
    }
    .left-section {
      .partner-logo {
        width: 90px;
      }
      .banner-title {
        font-size: 38px;
      }
      .banner-description {
        font-size: 16px;
      }
      .explore-btn {
        font-size: 15px;
        padding: 11px 22px;
      }
    }
    .right-section {
      margin-top: 20px;
      .widget-row {
        flex-direction: column;
        .widget {
          width: 100%;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
